module.exports = __webpack_public_path__ + "static/media/business-safes.b37d20d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/business-safes.jpg
// module id = 1236
// module chunks = 0